const imgUrl = [
  require('../../../assets/img/solutions/Tencent/圆角矩形 3 拷贝 6.png'),
  require('../../../assets/img/solutions/Tencent/公众号开发.gif'),
  require('../../../assets/img/solutions/Tencent/组 2.png'),
];

export default imgUrl;
